<template>
  <div class="list-shell">
    <div class="list-header">
      <div class="list-header__left">
        <div class="list-title">
          <i class="fa-duotone fa-rectangle-list"></i>
          <span>List View</span>
        </div>

        <div class="list-sub">
          <span class="chip chip--count">{{ displayTotal }} total</span>
        </div>
      </div>

      <div class="list-header__center">
        <div class="searchbox">
          <i class="fa-duotone fa-magnifying-glass searchbox__icon"></i>

          <input
            class="searchbox__input"
            type="text"
            v-model="searchProxy"
            placeholder="Search borrower, loan #, condition, address, status, LO/Proc/UW…"
          />

          <button
            v-if="searchProxy"
            class="searchbox__clear"
            type="button"
            title="Clear"
            @click="searchProxy = ''"
          >
            <i class="fa-duotone fa-xmark"></i>
          </button>
        </div>
      </div>


    </div>

    <div class="list-body">
      <div class="card-list">
        <ConditionCard
          v-for="it in safeItems"
          :key="it.conditionId || it.id || `${it.loanId}-${it.title}`"
          :item="it"
          :team="it.team || []"
          :photo-url="photoUrl"
          :is-photo-loading="isPhotoLoading"
          :close-pill-class="safeClosePillClassFn(it)"
          @open-loan="(...args) => $emit('open-loan', ...args)"
          @open-encompass="(...args) => $emit('open-encompass', ...args)"
          @open-video="(...args) => $emit('open-video', ...args)"
          @open-teams="(...args) => $emit('open-teams', ...args)"
          @open-email="(...args) => $emit('open-email', ...args)"
          @img-error="(...args) => $emit('img-error', ...args)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ConditionCard from "./ConditionCard.vue"

export default {
  name: "ConditionsList",
  components: { ConditionCard },
  props: {
    items: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    photoUrl: { type: Function, required: true },
    isPhotoLoading: { type: Function, required: true },
    closePillClassFn: { type: Function, default: null },
    searchText: { type: String, default: "" }
  },
  computed: {
    safeItems() {
      return Array.isArray(this.items) ? this.items : []
    },
    displayTotal() {
      const t = Number(this.total || 0)
      if (t > 0) return t
      return this.safeItems.length
    },
    safeClosePillClassFn() {
      return typeof this.closePillClassFn === "function" ? this.closePillClassFn : () => "pill--neutral"
    },
    searchProxy: {
      get() {
        return this.searchText
      },
      set(val) {
        this.$emit("search-input", val)
      }
    }
  }
}
</script>

<style scoped>
.list-shell {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.list-header {
  display: grid;
  grid-template-columns: auto minmax(280px, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 10px 10px 10px 10px;
  border-bottom: 1px solid var(--border-ltr);
  background: rgba(5, 29, 58, 0.03);
}

.list-header__left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 220px;
}

.list-header__center {
  min-width: 0;
}

.list-header__right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 0;
}

.right-spacer {
  width: 140px;
  height: 1px;
}

.list-title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 1000;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text-secondary-on-background);
}

.list-title i {
  color: var(--notification-blue);
  --fa-primary-color: var(--notification-blue);
  --fa-secondary-color: rgba(40, 110, 255, 0.45);
  font-size: 13px;
}

.list-sub {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid rgba(5, 29, 58, 0.12);
  background: rgba(5, 29, 58, 0.04);
  font-size: 11px;
  font-weight: 950;
  color: var(--text-secondary-on-background);
  line-height: 1;
}

.chip--count {
  border-color: rgba(40, 110, 255, 0.18);
  background: rgba(40, 110, 255, 0.06);
  color: var(--text-primary-on-background);
}

.searchbox {
  position: relative;
  width: 100%;
}

.searchbox__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.75;
  pointer-events: none;
}

.searchbox__input {
  width: 100%;
  height: 40px;
  padding: 0 40px 0 38px;
  border: 1px solid var(--border-lt);
  border-radius: 12px;
  background: var(--background);
  color: var(--text-primary-on-background);
  font-size: 13px;
  font-weight: 800;
}

.searchbox__input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(5, 29, 58, 0.15);
}

.searchbox__clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.85;
}

.searchbox__clear:hover {
  opacity: 1;
  color: var(--primary);
}

.list-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.card-list {
  padding: 10px 8px 12px 8px;
}
</style>
